<template>
  <ApolloMutation
    style="display: inline-block"
    :mutation="
      (gql) => gql`
        mutation RequestReviewForStory($id: ID!, $status: String) {
          updateStory(input: { id: $id, status: $status }) {
            story {
              id
              status {
                id
                _id
              }
            }
          }
        }
      `
    "
    :variables="{
      id: id,
      status: status,
    }"
    v-slot="{ mutate, loading }"
  >
    <v-btn
      :loading="loading"
      :disabled="!active"
      color="primary"
      @click="mutate()"
    >
      {{ $t("storyHub.publishing.wizard.submitForApproval") }}
    </v-btn>
  </ApolloMutation>
</template>
<script>
import iris from "@/iris";
export default {
  props: {
    active: Boolean,
  },
  computed: {
    id() {
      return iris.story + this.$route.params.id;
    },
    status() {
      return iris.status + "In Review";
    },
  },
};
</script>